import React from 'react';

import classnames from 'classnames';

import { ChevronDown, EvSvgIcon } from '@evinced-private/ui-common';

import { AriaHaspopup } from 'src/common/types';

import './NavigationMenuTrigger.scss';

interface NavigationMenuTriggerProps {
	id: string;
	isOpen: boolean;
	disabled: boolean;
	ariaLabel: string;
	labelId?: string;
	displayText: string;
	onClick: () => void;
	onKeyDown: (event: React.KeyboardEvent) => void;
	triggerRef: React.RefObject<HTMLButtonElement>;
	ariaHaspopup?: AriaHaspopup;
	ariaExpanded?: boolean;
	ariaControls?: string;
	children?: React.ReactNode;
}

export const NavigationMenuTrigger: React.FC<NavigationMenuTriggerProps> = ({
	id,
	isOpen,
	disabled,
	ariaLabel,
	labelId,
	displayText,
	onClick,
	onKeyDown,
	triggerRef,
	ariaHaspopup = 'true',
	ariaExpanded,
	ariaControls,
	children
}) => {
	return (
		<div className="navigation-menu-trigger">
			<div className="navigation-menu-trigger__text">{displayText}</div>

			<div className="navigation-menu-trigger__button-wrapper">
				<button
					ref={triggerRef}
					id={id}
					type="button"
					className="navigation-menu-trigger__button"
					aria-haspopup={ariaHaspopup || 'true'}
					aria-expanded={(ariaExpanded ?? isOpen) ? 'true' : 'false'}
					aria-controls={ariaControls}
					aria-labelledby={labelId}
					aria-label={ariaLabel ? `${ariaLabel}, ${displayText}` : `${displayText}, menu button`}
					disabled={disabled}
					onClick={onClick}
					onKeyDown={onKeyDown}
				>
					<span
						className={classnames('navigation-menu-trigger__arrow', {
							'navigation-menu-trigger__arrow--up': isOpen
						})}
						aria-hidden="true"
					>
						<EvSvgIcon icon={ChevronDown} isSmall />
					</span>
				</button>
				{children}
			</div>
		</div>
	);
};
